import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCalendarLockIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={21}
    fill="none"
    viewBox="0 0 21 21"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.826 17.935H5.409a1.667 1.667 0 0 1-1.667-1.667v-10A1.667 1.667 0 0 1 5.41 4.602h10a1.667 1.667 0 0 1 1.667 1.666v3.334M13.742 2.938V6.27M7.078 2.938V6.27M3.742 9.602h13.334"
    />
    <path
      fill="#000"
      d="M15.001 15.33a.333.333 0 0 1 .334.334v1a.333.333 0 1 1-.667 0v-1a.333.333 0 0 1 .333-.333m-1.666-1.333v-.666a1.667 1.667 0 0 1 3.333 0v.666a1 1 0 0 1 1 1v2.334a1 1 0 0 1-1 1h-3.333a1 1 0 0 1-1-1v-2.334a1 1 0 0 1 1-1M16 13.331a1 1 0 0 0-2 0v.666h2zm-3 4a.333.333 0 0 0 .334.333h3.333a.333.333 0 0 0 .333-.333v-2.334a.333.333 0 0 0-.333-.333h-3.333a.333.333 0 0 0-.334.333z"
    />
  </svg>
);
export default SvgCalendarLockIcon;
